import { useMemo } from 'react';

const useTrainingSessionMetrics = trainingSession => {
  return useMemo(() => {
    if (!trainingSession) {
      return null;
    }
    const directScoreFields = {
      centering_score: 'centering',
      swing_score: 'swing'
    };

    const breakdownMetrics = ['compass', 'depth', 'gain', 'lift', 'peak', 'vertical'];

    const metrics = [];

    // Add direct score fields
    Object.entries(directScoreFields).forEach(([dataKey, metricKey]) => {
      const score = trainingSession[dataKey];
      if (score !== null && score !== undefined) {
        metrics.push({
          metric: metricKey,
          score: Number(score)
        });
      }
    });

    // Calculate metrics from session breakdowns if available
    const breakdowns = trainingSession?.details?.session_breakdowns;
    if (Array.isArray(breakdowns) && breakdowns.length > 0) {
      breakdownMetrics.forEach(metric => {
        if (!metrics.find(m => m.metric === metric)) {
          const passedCount = breakdowns.filter(
            breakdown => breakdown[metric] === true
          ).length;
          const percentage = (passedCount / breakdowns.length) * 100;
          metrics.push({
            metric,
            score: percentage
          });
        }
      });
    }

    return metrics.length > 0 ? metrics : null;
  }, [trainingSession]);
};

export default useTrainingSessionMetrics;
